<template>
	<fragment>
		<common-header
			name="메뉴관리"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
		></common-header>

		<section ref="container" class="container" style="display: flex; align-items: center; justify-content: center;">
			<!-- <nav class="side-nav">
				&nbsp;
			</nav> -->

			<div class="clearfix">
				<!-- <div class="btn-group-box b-b m-b-30 clearfix">
					<div class="pull-right m-b-15 clearfix">
						<button class="btn bg-deepblue text-white round w140">안내</button>
					</div>
				</div> -->

				<div class="cat_item v-top cate2">
					<h3>대분류</h3>
					<table class="full-width table-condensed table-hover text-center">
						<vue-draggable v-model="categories[0]" tag="tbody" handle=".handle"
							v-bind="dragOptions" @end="dragEnd(0, $event)">
							<tr v-for="(item,index) in categories[0]"
								v-bind:class="select[0] == item.categoryId || modifies[0] === index ? 'on' : ''"
								:key="'cate-a-'+item.name+'-'+index"
								@click="getMenuData(item.categoryId, 1)(); selectMenu(item.categoryId, 0)()">
								<td class="text-left">{{item.name}}</td>
								<td class="">
									<a class="link m-r-5 handle" @click="openRegLinkModal(0,index, item.categoryId, item.link)">링크</a> 
									<a class="move m-r-5 handle">이동</a>
									<a class="modify m-r-5" :class="modifies[0] === index ? 'on' : ''"
										@click="clickModifyMemu(index, 0, $event)">수정</a>
									<a class="del" @click="deleteMenu(index, 0)($event)">삭제</a>
								</td>
							</tr>
						</vue-draggable>
					</table>
					<hr>
					<table class="full-width table-condensed text-center m-t-15">
						<tbody>
							<tr>
								<td >
									<input class="inline form-control-sm m-b-0 w240 v-mid round"
										type="text" placeholder="대분류명 입력" v-model="categoriesInput[0]">
									<button class="btn-sm bg-deepblue text-white round" v-if="modifies[0] === -1"
										type="button" @click="putMenu(0)()">추가</button>
									<button class="btn-sm bg-deepblue text-white round" v-else
										type="button" @click="patchMemu(0)()">완료</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="cat_item v-top cate2">
					<h3>중분류</h3>
					<table class="full-width table-condensed table-hover text-center">
						<vue-draggable v-model="categories[1]" tag="tbody"
							handle=".handle" v-bind="dragOptions"  @end="dragEnd(1, $event)">
							<tr v-for="(item,index) in categories[1]"
								:key="'cate-a-'+item.name+'-'+index"
								v-bind:class="select[1] == item.categoryId ? 'on' : ''"
								@click="getMenuData(item.categoryId, 2)(); selectMenu(item.categoryId, 1)()">
								<td class="text-left">{{item.name}}</td>
								<td class="">
									<a class="link m-r-5 handle" @click="openRegLinkModal(1,index, item.categoryId, item.link)">링크</a> 
									<a class="move m-r-5 handle">이동</a>
									<a class="modify m-r-5" :class="modifies[1] === index ? 'on' : ''"
										@click="clickModifyMemu(index, 1, $event)">수정</a>
									<a class="del" @click="deleteMenu(index, 1)()">삭제</a>
								</td>
							</tr>
						</vue-draggable>
					</table>
					<hr>
					<table class="full-width table-condensed text-center m-t-15">
						<tbody>
							<tr>
								<td>
									<input class="inline form-control-sm m-b-0 w240 v-mid round"
										type="text" placeholder="중분류명 입력" v-model="categoriesInput[1]">
									<button class="btn-sm bg-deepblue text-white round" v-if="modifies[1] === -1"
										type="button" @click="putMenu(1)()">추가</button>
									<button class="btn-sm bg-deepblue text-white round" v-else
										type="button" @click="patchMemu(1)()">완료</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="cat_item v-top">
					<h3>소분류</h3>
					<table class="full-width table-condensed table-hover text-center">
						<vue-draggable v-model="categories[2]" tag="tbody" handle=".handle" v-bind="dragOptions"  @end="dragEnd(2, $event)">
							<tr v-for="(item,index) in categories[2]" :key="'cate-a-'+item.name+'-'+index">
								<td class="text-left">{{item.name}}</td>
								<td class="">
									<a class="link m-r-5 handle" @click="openRegLinkModal(2,index, item.categoryId, item.link)">링크</a> 
									<a class="move m-r-5 handle">이동</a>
									<a class="modify m-r-5" :class="modifies[2] === index ? 'on' : ''"
										@click="clickModifyMemu(index, 2, $event)">수정</a>
									<a class="del" @click="deleteMenu(index, 2)()">삭제</a>
								</td>
							</tr>
						</vue-draggable>
					</table>
					<hr>
					<table class="full-width table-condensed text-center m-t-15">
						<tbody>
							<tr>
								<td>
									<input class="inline form-control-sm m-b-0 w240 v-mid round" type="text" placeholder="소분류명 입력" v-model="categoriesInput[2]">
									<button class="btn-sm bg-deepblue text-white round" v-if="modifies[2] === -1"
										type="button" @click="putMenu(2)()">추가</button>
									<button class="btn-sm bg-deepblue text-white round" v-else
										type="button" @click="patchMemu(2)()">완료</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</section>
		<modal-alert :config="modals.ModalAlert"
		@close="modals.ModalAlert.show=false;"
		:key="hash(modals.ModalAlert)"
		></modal-alert>
		<modal-menu-register-link :config="modals.ModalMenuRegisterLink" 
		@close="modals.ModalMenuRegisterLink.show=false;"
		@regLink="regLink">
		</modal-menu-register-link>
		<common-footer></common-footer>
	</fragment>
</template>

<script>
import axios from 'axios'
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import VueDraggable from 'vuedraggable'
import CommonHeader from '../components/CommonHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import ModalMenuRegisterLink from '../modals/ModalMenuRegisterLink.vue'
import ModalAlert from "../modals/ModalAlert.vue";
import server from '../statics/server'

export default {
	name: "ViewMenuManager",
	mixins: [fnAdjustHeight],

	// 컴포넌트가 그려지기 직전에 호출되는 함수
	mounted: function() {
		this.getMenuData(0, 0)();
	},

	components: {
		VueDraggable,
		CommonHeader,
		CommonFooter,
		ModalMenuRegisterLink,
		ModalAlert,
	},

	data: function() {
		return {
			menus: [ // 서브메뉴
				{name:'메뉴 관리',link:"/menu",selected:true},
			],
			modals: {
				ModalMenuRegisterLink: ModalMenuRegisterLink.default(),
				ModalAlert: ModalAlert.default()
			},
			buttons: [], // 헤더버튼
			categoriesInput: ["", "", ""], // 카테고리 입력 값 : 0 대분류 1 중분류 2 소분류
			categories: [ [], [], [] ],
			modifies: [-1, -1, -1],
			select: ["", "", ""], // 선택된 카테고리
			
		}
	},

	methods: {
		getMenuData: function(parentsId, categoryLevel = 0) {
			return async () => {
				try {
					for(let i = categoryLevel + 1; i < 3 ;i++) {
						this.$set(this.categories, i, []);
					}

					const { data } = await axios.post(server.addr() + server.api.MENU, { parentsId });

					this.$set(this.categories, categoryLevel, data.list);
				} catch (e) {
					// TODO : write error exception
				}
			}
		},
		putMenu: function (categoryLevel) {
			return async () => {
				let parentsId = "0";
				// 대카테고리는 parentsId = 0 이다
				if( categoryLevel != 0 ) {
					// TODO: set parents id
					parentsId = this.select[categoryLevel - 1];
				}

				try {
					const name = this.categoriesInput[categoryLevel];
					const { data } = await axios.put(server.addr() + server.api.MENU, [{
						parentsId, name
					}]);

					this.categories[categoryLevel].push({
						...data.list[0]
					});
				} catch(e) {
					// TODO: post event error
				}

				this.$set(this.categoriesInput, categoryLevel, "");
			}
		},
		patchMemu: function (categoryLevel) {
			return async () => {
				try {
					const index = this.modifies[categoryLevel];
					const name = this.categoriesInput[categoryLevel];
					const targetCategory = this.categories[categoryLevel][index];

					await axios.patch(`${server.addr()}${server.api.MENU}/${targetCategory.categoryId}`, {
						name
					});

					this.categories[categoryLevel][index].name = name;
				} catch(e) {
					// TODO: post event error
				}

				this.$set(this.categoriesInput, categoryLevel, "");
				this.$set(this.modifies, categoryLevel, -1);
			}
		},
		selectMenu: function(categoryId, categoryLevel) {
			return () => {
				for(let i = categoryLevel + 1; i < 3 ;i++) {
					this.$set(this.select, i, ""); // 밑에 레벨의 select 초기화
				}

				this.$set(this.select, categoryLevel, categoryId); // 선택된 categoryId 저장
			}
		},
		deleteMenu: function(categoryIndex, categoryLevel) {
			return async () => {
				const category = this.categories[categoryLevel][categoryIndex];
				try {
					await axios.delete(`${server.addr()}${server.api.MENU}/${category.categoryId}`);

					this.categories[categoryLevel].splice(categoryIndex, 1);
				} catch(e) {
					// TODO: erro exception
				}
			}
		},
		regLink : async function(config){
			const categoryLevel = config.categoryLevel;
			const index = config.index;
			const link = config.link;
			try {
				await axios.patch(`${server.addr()}${server.api.MENU}/${config.categoryId}`, {
					link
				});
				this.modals.ModalMenuRegisterLink.show = false;
				
					// eslint-disable-next-line
				console.log(this.categories, categoryLevel, index)
				this.categories[categoryLevel][index].link = link;

				this.modals.ModalAlert.msg = "등록되었습니다.";
				this.modals.ModalAlert.show = true;
			} catch(e) {
				console.log(e);
				// TODO: 서버쪽 오류랑 매핑시킬 것!
				this.modals.ModalAlert.msg = "서버와 통신할 수 없습니다.";
				this.modals.ModalAlert.show = true;
			}
		},
		openRegLinkModal: function(categoryLevel,index, categoryId, link){
			this.modals.ModalMenuRegisterLink.categoryLevel = categoryLevel;
			this.modals.ModalMenuRegisterLink.index = index;
			this.modals.ModalMenuRegisterLink.categoryId = categoryId;
			this.modals.ModalMenuRegisterLink.link = link;
			this.modals.ModalMenuRegisterLink.show = true;
		},
		// 수정 버튼 클릭시
		clickModifyMemu: function(categoryIndex, categoryLevel) {
			this.$set(this.categoriesInput, categoryLevel, this.categories[categoryLevel][categoryIndex].name);
			this.$set(this.modifies, categoryLevel, categoryIndex);
		},
		dragEnd: async function(categoryLevel, $event) {
			const { newIndex } = $event;
			const targetCategory = this.categories[categoryLevel][newIndex];
			let dst = 0;
			if(newIndex !== 0) {
				const dstCategory = this.categories[categoryLevel][newIndex - 1];
				dst = dstCategory.categoryId;
			}
			try {
				await axios.patch(`${server.addr()}${server.api.MENU}/${targetCategory.categoryId}`, {
					dst
				});
			} catch(e) {
				// TODO: error exception
			}
		}
	},

	// 미리 계산된 option 값 들
	computed: {
		dragOptions() {
			return {
				ghostClass: "ghost"
			}
		}
	}
}
</script>

<style>
.cat_item tr:hover {
	background: none;
	box-shadow: none;
}
.ghost {
	box-shadow: 0px 2px 5px 2px rgba(0, 0, 0, 0.2) !important;
	background-color: #e1e3eb !important;
}
</style>